import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP4UnderUtilizedOvw202606: FaireAdPerformancePeriodEntity = {
  token: "perf_p4_under_utilized_ovw_202606",
  type: "adPerformancePeriod",
  scope: "OVERVIEW",
  periodType: "RECEIPT",
  startDate: "2026-06-01",
  endDate: "2026-06-30",
  impressions: 26314,
  clicks: 444,
  adsSpendDollars: 2670,
  budgetDollars: 15000,
  salesDollars: 7109,
  bestEstimateRoas: 2.66,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.18,
  newCustomersAcquired: 9,
  reorderConversions: 7,
  dataAvailableAtDate: "2026-07-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
